import logo from './logo.svg';
import './App.css';
import Homepage from './components/pages/Homepage';
import Navbar from './components/inc/Navbar';
import { BrowserRouter,Route,Routes } from 'react-router-dom';
import About from './components/pages/About';
import Auctions from './components/pages/Auctions';
import VehicleDetails from './components/pages/VehicleDetails';
import WatchList from './components/pages/WatchList';
import MyBids from './components/pages/MyBids';
import ContactUs from './components/pages/ContactUs';
import LoginSignup from './components/pages/LoginSignup';
import BuyersServices from './components/pages/BuyersServices';
import Region from './components/pages/Region';
import CaseAuctions from './components/pages/CaseAuctions';
import ClientServices from './components/pages/ClientServices';
import UserProfile from './components/pages/UserProfile';
import PayOnline from './components/pages/PayOnline';
import TermsOfUse from './components/pages/TermsOfUse';
import YourWins from './components/pages/YourWins';
import ChangePassword from './components/pages/ChangePassword';
import VehicleGallery from './components/pages/VehicleGallery';
import ForgotPassword from './components/pages/ForgotPassword';

import ReadyToLift from './components/pages/ReadyToLift';
import PrivacyPolicy from './components/pages/PrivacyPolicy';
import DeleteAccount from './components/pages/DeleteAccount';


function App() {

  
  return (
    
   <BrowserRouter >
      <Navbar/>
      <Routes >
      <Route path="/" element={<Homepage/>} />
      <Route path="/About" element={<About/>} />
      <Route path="/Auctions" element={<Auctions/>} />
      <Route path="/VehicleDetails/:id" element={<VehicleDetails/>} />
      <Route path="/vehicleGallery/:id" element={<VehicleGallery/>} />
      <Route path='/WatchList' element={<WatchList/>} />
      <Route path='/MyBids' element={<MyBids/>} />
      <Route path='/ContactUs' element={<ContactUs/>} />
      <Route path='/LoginSignup' element={<LoginSignup/>} />
      <Route path='/BuyersServices' element={<BuyersServices/>} />
      <Route path='/ClientServices' element={<ClientServices/>} />
      <Route path='/ForgotPassword' element={<ForgotPassword/>} />
      
      <Route path="/Region/:zone" element={<Region/>} />
      <Route path='/Cases/:id' element={<CaseAuctions/>} />
      <Route path='/ReadyToLift/:id' element={<ReadyToLift/>} />
      <Route path="/profile" element={<UserProfile/>} />
      <Route path='/PayOnline' element={<PayOnline/>} />
      <Route path="/TermsOfUse" element={<TermsOfUse/>} />
      <Route path='/YourWins' element={<YourWins/>} />
      <Route path='/ChangePassword' element={<ChangePassword/>} />
      <Route path="/PrivacyPolicy" element={<PrivacyPolicy/>} />
      <Route path="/DeleteAccount" element={<DeleteAccount/>} />
      </Routes>
   </BrowserRouter>
    
  );
}

export default App;
